module.exports = __webpack_public_path__ + "img/lt.36fd4537.svg";